import React, { Component } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

import "./descuentosCaptahuella.css";
import Alert from "../../modal/alert";

class DescuentosCaptahuella extends Component {
  constructor(props) {
    super(props);
    this.state = {
      descripcion: "",
      listaDescuentos: [],
      mensajealerta: false,
      tituloM: "",
      cuerpoM: "",
    };
  }

  componentDidMount() {
    this.buscarDescuentos();
  }

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleClose = () => {
    this.setState({ mensajealerta: false });
  };

  buscarDescuentos = () => {
    const data = new FormData();
    data.append("boton", "buscarDescuentosCaptahuella");

    const config = {
      headers: {
        "Content-Type": "text/html",
      },
    };

    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/descuentosCaptahuella.php";

    axios.post(xurl, data, config).then((res) => {
      if (res.data.variable1 && Array.isArray(res.data.variable2)) {
        this.setState({
          listaDescuentos: res.data.variable2,
        });
      } else {
        this.setState({
          listaDescuentos: [],
        });
      }
    });
  };

  guardar = () => {
    const { descripcion } = this.state;

    if (!descripcion.trim()) {
      this.setState({
        mensajealerta: true,
        tituloM: "Descuentos Captahuella",
        cuerpoM: "Debe indicar la descripción del tipo de descuento.",
      });
      return;
    }

    const data = new FormData();
    data.append("descripcion", descripcion.trim());
    data.append("boton", "guardarDescuentoCaptahuella");

    const config = {
      headers: {
        "Content-Type": "text/html",
      },
    };

    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/descuentosCaptahuella.php";

    axios.post(xurl, data, config).then((res) => {
      if (res.data.variable1) {
        this.setState({
          descripcion: "",
          mensajealerta: true,
          tituloM: "Descuentos Captahuella",
          cuerpoM: res.data.variable2 || "Descuento guardado correctamente.",
        });
        this.buscarDescuentos();
      } else {
        this.setState({
          mensajealerta: true,
          tituloM: "Descuentos Captahuella",
          cuerpoM: res.data.variable2 || "Ocurrió un problema al guardar.",
        });
      }
    });
  };

  eliminar = (id) => {
    if (!id) return;

    const data = new FormData();
    data.append("iddescuentos", String(id));
    data.append("boton", "eliminarDescuentoCaptahuella");

    const config = {
      headers: {
        "Content-Type": "text/html",
      },
    };

    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/descuentosCaptahuella.php";

    axios.post(xurl, data, config).then((res) => {
      if (res.data.variable1) {
        this.setState({
          mensajealerta: true,
          tituloM: "Descuentos Captahuella",
          cuerpoM: res.data.variable2 || "Registro eliminado correctamente.",
        });
        this.buscarDescuentos();
      } else {
        this.setState({
          mensajealerta: true,
          tituloM: "Descuentos Captahuella",
          cuerpoM: res.data.variable2 || "Ocurrió un error al eliminar.",
        });
      }
    });
  };

  render() {
    const { descripcion, listaDescuentos, mensajealerta, tituloM, cuerpoM } =
      this.state;

    return (
      <div className="principal-pago row">
        <div className="contenedor-cxc col-12">
          <div className="titulo-cxc ">
            <p>DESCUENTOS CAPTAHUELLA</p>
          </div>

          {mensajealerta && (
            <Alert
              tituloMensaje={tituloM}
              cuerpoMensaje={cuerpoM}
              open={mensajealerta}
              handleClose={this.handleClose}
            />
          )}

          <div className="contenedorp row">
            <div className="contenedorcedula1x col-12">
              <input
                className="form-control"
                type="text"
                name="descripcion"
                id="descripcion"
                autoComplete="off"
                placeholder="Descripción del tipo de descuento"
                maxLength="150"
                onChange={this.onChange}
                value={descripcion.toUpperCase()}
              />
            </div>
            <div className="xcontenedorcedula1x col-12">
              <button className="boton" onClick={this.guardar}>
                Agregar
              </button>
              <Link to="/">
                <button className="boton">Salir</button>
              </Link>
            </div>
          </div>

          <div className="cont-listmedix row">
            <div className="listcxcx col-12">
              <table className="tablacxcx" border="1">
                <thead>
                  <tr>
                    <th className="titucxc2">DESCRIPCIÓN DEL DESCUENTO</th>
                    <th className="titucxc3x">
                      <span className="titulo-eliminar">
                        <span className="cerrarme3"></span>
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {listaDescuentos.map((item, i) => (
                    <tr
                      className={i % 2 === 0 ? "odd" : "odd"}
                      key={item.variable1}
                      id="tabla"
                    >
                      <td className="totalescxcx">{item.variable2}</td>
                      <td className="xcerr">
                        <span
                          className="cerrarme1"
                          onClick={() => this.eliminar(item.variable1)}
                        ></span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default DescuentosCaptahuella;

